import { useCallback } from 'react';
import Swal from 'sweetalert2';
import loadingGif from '../../assets/images/Innobo-Hub-loading.gif';

export const useLoadingModal = () => {
    const hideProgress = useCallback(() => {
        Swal.close();
    }, []);

    const showProgress = useCallback(() => {
        const brandLocalS = JSON.parse(localStorage.getItem('brand') || '');
        Swal.fire({
            title: 'Loading data',
            backdrop: true,
            width: 500,
            allowEscapeKey: false,
            allowOutsideClick: false,
            timerProgressBar: true,
            allowEnterKey: false,
            showConfirmButton: false,
            html: `<div style="display: flex; justify-content: center; align-items: center;">
              <img src="${brandLocalS.urlLoading ?? loadingGif}" alt="Loading..." style="width:100px; margin: 20px;" />
              </div>`,
            didOpen: () => {
                // Swal.showLoading();
            },
        });
    }, []);
    return { showProgress, hideProgress };
};
